<template>
  <div style="margin: 10px">
    <v-form>
      <v-card>
        <div class="headline dialog-header" v-if="showDialogHeader">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px"
            >{{ $t(formName) }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>
        <v-card-text>
           <v-layout>
            <v-flex>
              <table class="lstTable">
                <tr>
                  <th rowspan="2">{{ $t('lang.material.materialType') }}</th>
                  <th rowspan="2">Tên vật tư</th>
                  <th rowspan="2" width="80">Đơn vị</th>
                  <th rowspan="2" width="150">Số lượng theo quy trình</th>
                  <th rowspan="2" width="100">Tồn kho</th>
                  <th :colspan="timeAmSelected.length == 0 ? 1 : timeAmSelected.length">Sáng</th>
                  <th :colspan="timePmSelected.length == 0 ? 1 : timePmSelected.length">Chiều</th>
                  <th rowspan="2">Tổng đề xuất</th>
                  <th rowspan="2" v-if="isDirector">Đơn giá</th>
                  <th rowspan="2" v-if="isDirector">Thành tiền</th>
                </tr>
                <tr>
                  <th v-if="timeAmSelected.length == 0" width="60"></th>
                  <template v-else v-for="(item, index) in timeAmSelected">
                    <th :key="'am1'+index" width="60">{{ item }}h</th>
                  </template>

                  <th v-if="timePmSelected.length == 0" width="60"></th>
                  <template v-else v-for="(item, index) in timePmSelected">
                    <th :key="'pm1'+index" width="60">{{ item }}h</th>
                  </template>
                </tr>
                <template v-for="(item, index) in lstMaterial">
                  <tr v-if="item.row === 0" :key="'mat'+index">
                    <td style="font-weight: bold">{{ item.typeName }}</td>
                    <td colspan="7">Không có vật tư</td>
                  </tr>
                  <tr v-else :key="'mat'+index">
                    <td :rowspan="item.row" v-if="item.row != undefined && parseInt(item.row) > 0"
                        style="font-weight: bold">{{ item.typeName }}
                    </td>
                    <td>{{ item.materialName }}</td>
                    <td style="text-align: center">{{ item.unit }}</td>
                    <td style="text-align: center">{{ item.total | currency }}</td>
                    <td style="text-align: center">{{ item.inventory | currency }}</td>

                    <td v-if="lstMaterial[index].quantityAm.length == 0"></td>
                    <template v-else v-for="(v2, k2) in lstMaterial[index].quantityAm">
                      <td v-if="lstMaterial[index].quantityAm[k2] != undefined" :key="'am' + k2">
                        <c-input-number
                            v-model="lstMaterial[index].quantityAm[k2].value"
                            @keydown="keyProcess"
                            @change="onInputChange"
                            :id="'input_' + index + '_' + k2"
                            :data-row="index"
                            :data-col="k2"
                            data-time="am"
                            style="text-align: center"
                            :disabled="true"
                        />
                      </td>
                      <td v-else :key="'am' + k2"></td>
                    </template>

                    <td v-if="lstMaterial[index].quantityPm.length == 0"></td>
                    <template v-else v-for="(v3, k3) in lstMaterial[index].quantityPm">
                      <td v-if="lstMaterial[index].quantityPm[k3] != undefined" :key="'pm' + k3">
                        <c-input-number
                            v-model="lstMaterial[index].quantityPm[k3].value"
                            @keydown="keyProcess"
                            @change="onInputChange"
                            :id="'input_' + index + '_' + (lstMaterial[index].quantityAm.length + k3)"
                            :data-row="index"
                            :data-col="lstMaterial[index].quantityAm.length + k3"
                            :data-col2="k3"
                            data-time="pm"
                            style="text-align: center"
                            :disabled="true"
                        />
                      </td>
                      <td v-else :key="'pm' + k3"></td>
                    </template>
                    <td style="text-align: center">{{ item.total_export | currency }}</td>
                    <td style="text-align: center" v-if="isDirector">{{ item.price != undefined ? item.price : 0 | currency }}</td>
                    <td style="text-align: center" v-if="isDirector">{{ item.amount != undefined ? item.amount : 0 | currency }}</td>
                  </tr>
                </template>
              </table>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>

          <v-btn v-if="showApprove" color="success" @click="onApprove" :disabled="loading">
            {{ $t("Phê duyệt") }}
          </v-btn>
          <v-btn v-if="showReject" color="error" @click="openDialogRejectApprove" :disabled="loading">
            {{ $t("Không phê duyệt") }}
          </v-btn>
          <v-btn v-if="showConfirm" color="success" @click="onConfirm" :disabled="loading">
            {{ $t("Xác nhận") }}
          </v-btn>
<!--          <v-btn v-if="showRejectConfirm" color="error" @click="onRejectApprove" :disabled="loading">-->
<!--            {{ $t("Không xác nhận") }}-->
<!--          </v-btn>-->

          <v-btn v-if="showPrint" color="info" @click="onPrint" :disabled="loading">
            {{ $t("In phiếu") }}
          </v-btn>
          <v-btn color="warning" @click="onCancel" :disabled="loading">
            {{ $t("lang.common.back") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <dialog-reject-approve
        :dialog="dialogRejectApprove"
        @close="closeDialogRejectApprove"
        @onRejectApprove="onRejectApprove"
    />
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import {message} from "../../../shared/message";
import {areaContants, roleConstants} from "@/constants";
import DialogRejectApprove from "@/views/admin/export_request/component/DialogRejectApprove";

export default {
  name: "ExportRequestSummaryView",
  components: {DialogRejectApprove, IDatepicker},
  props: {
    valuesProp: {
      type: Object,
      default: ()=> {}
    },
    showDialogHeader: {
      type: Boolean,
      default: true,
    },
  },
  data: () => {
    return {
      dialogRejectApprove: false,
      values: {
        areaId: "-1",
        exportDate: ""
      },
      exportIdIn: "-1",
      formName: "Tổng hợp đề nghị xuất kho",
      loading: false,
      roleGroup: 2,
      warehouseId: '',
      cropCode: '',
      areaCode: '',
      procedureCode: '',
      famerName: '',
      timeAmSelected: [],
      timePmSelected: [],
      numberGList: areaContants.numberGList,
      lstG: [],
      timeAm: [],
      timePm: [],
      materials: [],
      lstSupplier: [],
      lstMaterialType: [],
      lstMaterialTmp: [],
      lstMaterial: [],
      lstImportWh: [],
      lstUser: [],
      lstProcedureData: [],
      requestOrder: null,
      isDisabled: false,
      role: '',
      exportRequest: '',
      createItem: {
        requestNumber: '',
        userCreateId: '',
        userCreateName: '',
        cropId: '',
        numberG: 1,
        exportType: 1,
        shrimpAge: '',
        status: 0,
      },
    };
  },

  created() {
    if(this.valuesProp != undefined
        && this.valuesProp.areaId!= undefined && this.valuesProp.areaId!= ""
        && this.valuesProp.status!= undefined  && this.valuesProp.status!= ""
        && this.valuesProp.requestDate!= undefined  && this.valuesProp.requestDate!= ""
    ){
      this.values.areaId = this.valuesProp.areaId;
      this.values.exportDate = this.valuesProp.exportDate;
      this.values.status = this.valuesProp.status;
      this.values.materialTypeAllyId = this.valuesProp.materialTypeAllyId;
    } else if(this.$route.params.areaId != undefined && this.$route.params.areaId !=""
        && this.$route.params.requestDate != undefined && this.$route.params.requestDate !=""
        && this.$route.params.status != undefined && this.$route.params.status !=""){
      this.values.areaId = this.$route.params.areaId;
      this.values.exportDate = this.$route.params.requestDate;
      this.values.status = this.$route.params.status;
      this.values.materialTypeAllyId = this.$route.params.materialTypeAllyId;
    }


  },
  computed: {
    isDirector() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR) {
        return true;
      } else {
        return false;
      }
    },
    showApprove() {
      // return true;
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
          && this.exportRequest.status == areaContants.exportRequestStatus.confirmed) {
        return true;
      } else {
        return false;
      }
    },
    showReject() {
      // return true;
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
          && this.exportRequest.status == areaContants.exportRequestStatus.confirmed) {
        return true;
      } else {
        return false;
      }
    },

    showRejectConfirm() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
          && this.exportRequest.status == areaContants.exportRequestStatus.created) {
        return true;
      } else {
        return false;
      }
    },
    showCancel  () {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
          && this.exportRequest.status == areaContants.exportRequestStatus.confirmed) {
        return true;
      } else {
        return false;
      }
    },
    showUpdate() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
          && this.exportRequest.status == areaContants.exportRequestStatus.confirmed) {
        return true;
      } else {
        return false;
      }
    },
    showConfirm () {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
          && this.exportRequest.status == areaContants.exportRequestStatus.created) {
        return true;
      } else {
        return false;
      }
    },
    showPrint () {
      // return true;
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.WAREHOUSE_KEEPER
          || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
          && this.exportRequest.status == areaContants.exportRequestStatus.approved) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    valuesProp: {
      handler(value) {
        this.values.areaId = value.areaId;
        this.values.exportDate = value.exportDate;
        this.values.status = value.status;
        this.values.materialTypeAllyId= value.materialTypeAllyId
      },
      deep: true
    },
    values: {
      handler(value) {
        let tempValue = Object.assign({}, value, {"exportType": 1})
        this.getPondArea(value.areaId);
        this.getExportRequestSummaryApprove(tempValue);
        

        // if(this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR){
        //   let tempValue = Object.assign({}, value, {"status": 2})
        //   this.getPondArea(value.areaId);
        //   this.getExportRequestSummaryApprove(tempValue);
        // } else if(this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER){
        //   let tempValue = Object.assign({}, value, {"status": 1})
        //   this.getPondArea(value.areaId)
        //   this.getExportRequestSummaryApprove(tempValue);
        // }
      },
      deep: true
    },
  },

  methods: {
    onCancel() {
      this.$router.push({path: '/exportRequest'});
    },
    onSave() {
      const total_export = this.lstMaterial.reduce((n, {total_export}) => n + total_export, 0)
      if (parseFloat(total_export) <= 0) {
        message.error("Bạn chưa nhập số lượng vật tư xuất kho");
        return;
      }

      this.loading = true;

      const createItem = this.createItem;
      createItem.requestData = JSON.stringify(this.lstMaterial);
      // console.log(createItem);
      // return;

      axios
          .post(process.env.VUE_APP_API_URL + "/exportRequest/save", createItem)
          .then(
              (data) => {
                if (data.success) {
                  message.success(
                      this.$t("lang.common.save_success")
                  );
                  this.onCancel();
                } else {
                  message.error(this.$t(data.description));
                }
                this.loading = false;
              },
              (error) => {
                this.loading = false;
                console.log(error);
              }
          );
    },
    onCancelExport() {
      this.loading = true;
      axios
          .post(process.env.VUE_APP_API_URL + "/exportRequest/reject", this.exportRequest)
          .then(
              (data) => {
                if (data.success) {
                  message.success(this.$t("lang.common.save_success"));
                  this.onCancel();
                } else {
                  message.error(this.$t("lang.common.save_error"));
                }
                this.loading = false;
              },
              (error) => {
                this.loading = false;
                console.log(error);
              }
          );
    },
    onApprove() {
      this.loading = true;
      const params = this.values;
      params.exportType = 1;
      axios
          .post(process.env.VUE_APP_API_URL + "/exportRequest/approveList", params)
          .then(
              (data) => {
                if (data.success) {
                  message.success(this.$t("lang.common.save_success"));
                  this.onCancel();
                } else {
                  message.error(this.$t("lang.common.save_error"));
                }
                this.loading = false;
              },
              (error) => {
                this.loading = false;
                console.log(error);
              }
          );
    },

    onConfirm() {
      this.loading = true;
      const params = this.values;
      params.exportType = 1;
      axios
          .post(process.env.VUE_APP_API_URL + "/exportRequest/confirmList", params)
          .then(
              (data) => {
                if (data.success) {
                  message.success(this.$t("lang.common.save_success"));
                  this.onCancel();
                } else {
                  message.error(this.$t("lang.common.save_error"));
                }
                this.loading = false;
              },
              (error) => {
                this.loading = false;
                console.log(error);
              }
          );
    },

    onRejectApprove(reason = '') {
      if(reason == ""){
        alert("Vui lòng nhập lý do không phê duyệt")
        return;
      }
      this.loading = true;
      const params = this.values;
      params.exportType = 1;
      axios
          .post(process.env.VUE_APP_API_URL + "/exportRequest/rejectList", params)
          .then(
              (data) => {
                if (data.success) {
                  message.success(this.$t("lang.common.save_success"));
                  this.onCancel();
                } else {
                  message.error(this.$t("lang.common.save_error"));
                }
                this.loading = false;
              },
              (error) => {
                this.loading = false;
                console.log(error);
              }
          );
    },


    onPrint() {
      this.values.exportType=1;
      axios({
        url: process.env.VUE_APP_API_URL + "/exportRequest/exportExcelSummary",
        method: "POST",
        data: this.values,
        responseType: "blob", // important
      }).then(response => {
        if (response) {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "De_nghi_xuat_kho_tong_hop" + ".xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        }
      });
    },
    getExportRequestSummaryApprove(values) {
      if (values.areaId != -1) {
        const params = values;
        params.exportType = 1;
        axios
            .post(
                process.env.VUE_APP_API_URL + "/exportRequest/searchSummaryApprove?pageSize=-1&page=-1",
                params
            )
            .then((data) => {
              if (data.items && data.items.length > 0) {
                const exportRequest = data.items[0];
                exportRequest.exportDate = moment(String(exportRequest.exportDate)).format('YYYY-MM-DD');
                this.lstMaterial = JSON.parse(exportRequest.requestData);
                console.log(this.lstMaterial);
                this.formatTimeSelected(this.lstMaterial[0]);
                this.exportRequest = exportRequest;

                if (exportRequest.status != 1 && this.roleGroup == 1) {
                  this.isDisabled = true;
                }
              }
            });
      }
    },
    getCrop(cropId) {
      axios.post(
          process.env.VUE_APP_API_URL + "/crop/search?pageSize=-1&page=-1",
          {cropId: cropId}
      )
          .then((data) => {
            if (data.items) {
              this.cropCode = data.items[0].code;

              // this.getEnvMeasure();
              // this.getPondArea(data.items[0].pondAreaId);
              this.getUser(data.items[0].users);
              // this.getShrimpAge(data.items[0]);
              this.getProcedureDetail(data.items[0].processId);
            }
          });
    },
    getPondArea(areaId) {
      axios.post(
          process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?categoryTypeCode=PONDAREA&pageSize=-1&page=-1",
          {categoryId: areaId}
      )
          .then((data) => {
            if (data.items) {
              this.areaCode = data.items[0].categoryName;
              this.getWarehouse(data.items[0].categoryId);
            }
          });
    },
    getWarehouse(parentId) {
      axios.post(
          process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?categoryTypeCode=WAREHOUSE&pageSize=-1&page=-1",
          {parentId: parentId}
      )
          .then((data) => {
            if (data.items) {
              this.warehouseId = data.items[0].categoryId;
              // this.getWarehouseInventory(data.items[0].categoryId);
            }
          });
    },
    // getWarehouseInventory(warehouseId) {
    //   axios.post(
    //       process.env.VUE_APP_API_URL + "/warehouse/search?pageSize=-1&page=-1",
    //       {warehouseId: warehouseId}
    //   )
    //       .then((data) => {
    //         if (data.items) {
    //           this.lstInventory = data.items;
    //           // this.calcuInventory();
    //         }
    //       });
    // },
    // setMaterialInventory(data) {
    //     console.log(this.lstMaterial);
    //     $.each(this.lstMaterial, function (k, v) {

    //     });
    // },
    getProcedureDetail(procedureId) {
      axios.post(process.env.VUE_APP_API_URL + "/procedureWh/detail/" + procedureId,
          {numberG: this.createItem.numberG}
      ).then(
          data => {
            this.procedureCode = data.procedureWh.code;
            // this.lstProcedureData = data;
            // this.reCalculate();
          }
      )
    },
    getUser(stringUser) {
      const uArr = stringUser.split(",");
      axios.post(
          process.env.VUE_APP_API_URL + "/user/list", {}
      )
          .then((data) => {
            if (data.content.length > 0) {
              const lstUser = data.content;
              const famers = lstUser.filter(function (e) {
                return uArr.indexOf(String(e.userId)) != -1;
              });
              if (famers) {
                let listUser = ''
                $.each(famers, function (k, v) {
                  if (k == 0) {
                    listUser += v.fullName;
                  } else {
                    listUser += ", " + v.fullName;
                  }
                });
                this.famerName = listUser;
              }
            }
          });
    },
    getImportWh(reqOrdId) {
      axios.post(
          process.env.VUE_APP_API_URL + "/importWh/search?pageSize=-1&page=-1",
          {status: 1, reqOrdId: reqOrdId}
      )
          .then((data) => {
            if (data.items) {
              this.lstImportWh = data.items;
            }
            this.calcTotalImportQuantity();
          });
    },
    getMaterialType() {
      axios.post(
          process.env.VUE_APP_API_URL + "/category/listByType?type=MATERIAL_TYPE"
      ).then(
          (data) => {
            if (data.length > 0) {
              this.lstMaterialType = data;
            }
          }
      );
    },
    // getEnvMeasure() {
    //     axios.post(
    //             process.env.VUE_APP_API_URL + "/envMeasure/search?pageSize=1&page=1",
    //             {cropId: this.createItem.cropId}
    //         )
    //         .then((data) => {
    //             if (data.items) {
    //                 this.envMeasure = data.items;
    //                 if (data.items[0].am != undefined) {
    //                     let amIndex = JSON.parse(data.items[0].am);
    //                     let g = amIndex.g.replace('G', '');
    //                     this.createItem.numberG = parseInt(g);
    //                 }
    //             }
    //         });
    // },

    keyProcess($event) {
      let group = 'input';
      let row = parseInt($event.target.getAttribute("data-row"));
      let col = parseInt($event.target.getAttribute("data-col"));
      switch ($event.keyCode) {
        case 13:
          col += 1;
          let id = group + '_' + row + '_' + col;
          var element = document.getElementById(id);
          if (typeof (element) != 'undefined' && element != null) {
            element.focus();
          } else {
            row += 1;
            col = 0;
            id = group + '_' + row + '_' + col;
            element = document.getElementById(id);
            if (typeof (element) != 'undefined' && element != null) {
              element.focus();
            }
          }
          $event.preventDefault();
          break;
        case 37:
          // left
          if (col >= 0) {
            col -= 1;
            let id = group + '_' + row + '_' + col;
            let element = document.getElementById(id);
            if (typeof (element) != 'undefined' && element != null) {
              element.focus();
            }
          }
          $event.preventDefault();
          break;
        case 38:
          // up
          if (row >= 0) {
            row -= 1;
            let id = group + '_' + row + '_' + col;
            let element = document.getElementById(id);
            if (typeof (element) != 'undefined' && element != null) {
              element.focus();
            }
          }
          $event.preventDefault();
          break;
        case 39:
          //right
          if (col >= 0) {
            col += 1;
            let id = group + '_' + row + '_' + col;
            // document.getElementById(id).focus();
            var element = document.getElementById(id);
            if (typeof (element) != 'undefined' && element != null) {
              element.focus();
            }
          }
          $event.preventDefault();
          break;
        case 40:
          //down
          if (row >= 0) {
            row += 1;
            let id = group + '_' + row + '_' + col;
            var element = document.getElementById(id);
            if (typeof (element) != 'undefined' && element != null) {
              element.focus();
            }
          }
          $event.preventDefault();
          break;
      }
    },
    minDate() {
      const minDate = moment().format('YYYY-MM-DD');
      return minDate;
    },
    onChangeG(event) {
      console.log(event);
    },
    onChangeTime($event, type) {
      let timeSelected = [];
      if (type == 'am') {
        this.timeAmSelected.sort((o1, o2) => {
          return o1 - o2;
        });
        timeSelected = this.timeAmSelected;
      } else {
        this.timePmSelected.sort((o1, o2) => {
          return o1 - o2;
        });
        timeSelected = this.timePmSelected;
      }

      for (let i = 0; i < this.lstMaterial.length; i++) {
        const quantity = [];
        let quantity_tmp = [];

        if (type == 'am') {
          quantity_tmp = this.lstMaterial[i].quantityAm;
        } else {
          quantity_tmp = this.lstMaterial[i].quantityPm;
        }

        $.each(timeSelected, function (k, v) {
          const t = quantity_tmp.filter(function (o) {
            return parseFloat(v) == o.time && o.value > 0;
          })
          let val = 0;
          if (t != undefined && t.length > 0) {
            val = t[0].value;
          }

          quantity.push({time: parseFloat(v), value: val});
        });
        quantity.sort((o1, o2) => {
          return o1.time - o2.time;
        });

        if (type == 'am') {
          this.lstMaterial[i].quantityAm = quantity;
        } else {
          this.lstMaterial[i].quantityPm = quantity;
        }

        this.calcuTotalExport(i);
      }
    },
    // getShrimpAge(item) {
    //     let shrimpAge = '';
    //     let dropDate = '';
    //     if (parseInt(item.pondParent) > 0 && item.dropDateParent != '' && item.dropDateParent != null) {
    //         dropDate = moment(String(item.dropDateParent));
    //     } else if (item.dropDate != '' && item.dropDate != null) {
    //         dropDate = moment(String(item.dropDate));
    //     }
    //     if (dropDate != '') {
    //         let endDate = moment();
    //         if (item.endDate) {
    //             endDate = moment(String(item.endDate));
    //             if (endDate > moment()) endDate = moment();
    //         }
    //         if (endDate > dropDate) {
    //             let dates = endDate.diff(dropDate, "days");
    //             if (dates >= 0) {
    //                 shrimpAge = dates + 1;
    //             }
    //         }
    //     }
    //     this.createItem.shrimpAge = shrimpAge;
    // },
    setTimeList() {
      for (let i = 1; i <= 12; i++) {
        this.timeAm.push({text: i + 'h', value: i});
      }
      for (let i = 13; i <= 24; i++) {
        this.timePm.push({text: i + 'h', value: i});
      }
    },
    reCalculate() {

      //
      // sum
      //
      this.lstMaterial = [];
      for (let i = 0; i < this.lstProcedureData.lstMaterial.length; i++) {
        this.lstMaterial.push(Object.assign({}, this.lstProcedureData.lstMaterial[i]));
      }

      for (let i = 0; i < this.lstMaterial.length; i++) {
        this.lstMaterial[i].total = 0;

        for (let j = 0; j < this.lstProcedureData.lstChildrenDay.length; j++) {
          let procedureDay = this.lstProcedureData.lstChildrenDay[j];
          if (procedureDay.shrimpAge == this.createItem.shrimpAge) {
            if (procedureDay.data == undefined || procedureDay.data == null || procedureDay.data == "") {
              continue;
            }
            let data = JSON.parse(procedureDay.data);
            let count = data[this.lstMaterial[i].materialId];
            if (count != undefined && count != null && count != "") {
              this.lstMaterial[i].total += parseFloat(count);
            }
          }
        }
        for (let j = 0; j < this.lstProcedureData.lstMotherDay.length; j++) {
          let procedureDay = this.lstProcedureData.lstMotherDay[j];
          if (procedureDay.shrimpAge == this.createItem.shrimpAge) {
            if (procedureDay.data == undefined || procedureDay.data == null || procedureDay.data == "") {
              continue;
            }
            let data = JSON.parse(procedureDay.data);
            let count = data[this.lstMaterial[i].materialId];
            if (count != undefined && count != null && count != "") {
              this.lstMaterial[i].total += parseFloat(count);
            }
          }
        }
      }
      //
      // remove item has total = 0 and not in material type
      //
      for (let i = this.lstMaterial.length - 1; i >= 0; i--) {
        if (this.lstMaterial[i].total == 0) {
          this.lstMaterial.splice(i, 1);
          continue;
        }
        let bRemove = true;
        for (let j = 0; j < this.lstMaterialType.length; j++) {
          if (this.lstMaterialType[j].categoryId == this.lstMaterial[i].typeId) {
            bRemove = false;
            break;
          }
        }
        if (bRemove) {
          this.lstMaterial.splice(i, 1);
        }
      }
      //
      // sort by typeId
      //
      this.lstMaterial.sort((o1, o2) => {
        if (o1.typeId == o2.typeId) {
          return o1.materialName.localeCompare(o2.materialName);
        } else {
          return o1.typeId - o2.typeId;
        }
      })

      for (let i = 0; i < this.lstMaterialType.length; i++) {
        this.lstMaterialType[i].count = 0;
        for (let j = 0; j < this.lstMaterial.length; j++) {
          if (this.lstMaterial[j].typeId == this.lstMaterialType[i].categoryId) {
            this.lstMaterialType[i].count++;
          }
        }
        if (this.lstMaterialType[i].count == 0) {
          this.lstMaterial.push({
            typeId: this.lstMaterialType[i].categoryId,
            typeName: this.lstMaterialType[i].categoryCode,
            row: 0
          })
        } else {
          for (let j = 0; j < this.lstMaterial.length; j++) {
            if (this.lstMaterial[j].typeId == this.lstMaterialType[i].categoryId) {
              this.lstMaterial[j].typeName = this.lstMaterialType[i].categoryCode;
              this.lstMaterial[j].row = this.lstMaterialType[i].count;
              break;
            }
          }
        }

      }

      // filter total > 0
      this.lstMaterial = this.lstMaterial.filter(function (e) {
        return e.total != undefined && e.total > 0;
      });

      // inventory
      // const lstInventory = this.lstInventory;
      for (let i = this.lstMaterial.length - 1; i >= 0; i--) {
        const lstMaterial = this.lstMaterial;

        lstMaterial[i].quantityAm = [];
        lstMaterial[i].quantityPm = [];
        lstMaterial[i].total_export = 0;
        // lstMaterial[i].inventory = 0;

        // const inv = lstInventory.filter(function (o) {
        //   return lstMaterial[i].materialId == o.materialId;
        // });
        // if (inv != undefined && inv[0] != undefined) {
        //   lstMaterial[i].inventory = inv[0].quantity;
        // }

        this.lstMaterial = lstMaterial;
      }
    },
    // calcuInventory() {
    //   const lstInventory = this.lstInventory;
    //   const lstMaterial = this.lstMaterial;

    //   $.each(lstMaterial, function (k, v) {
    //     const inv = lstInventory.filter(function (o) {
    //       return lstMaterial[k].materialId == o.materialId;
    //     });
    //     if (inv != undefined && inv[0] != undefined) {
    //       lstMaterial[k].inventory = inv[0].quantity;
    //     }
    //   });
    //   this.lstMaterial = lstMaterial;
    // },
    onInputChange($event) {
      const row = parseInt($event.target.getAttribute("data-row"));
      this.calcuTotalExport(row);
    },
    calcuTotalExport(row = 0) {
      const item = this.lstMaterial[row];
      const totalAm = item.quantityAm.reduce((n, {value}) => n + parseFloat(value), 0);
      const totalPm = item.quantityPm.reduce((n, {value}) => n + parseFloat(value), 0);

      const lstMaterial = this.lstMaterial;
      this.lstMaterial = [];
      lstMaterial[row].total_export = totalAm + totalPm;
      this.lstMaterial = lstMaterial;
    },
    formatTimeSelected(item) {
      const timeAm = [];
      const timePm = [];

      item.quantityAm.forEach((v) => {
        timeAm.push(parseInt(v.time));
      });
      item.quantityPm.forEach((v) => {
        timePm.push(parseInt(v.time));
      });

      this.timeAmSelected = timeAm;
      this.timePmSelected = timePm;
    },
    openDialogRejectApprove() {
      this.dialogRejectApprove = true;
    },
    closeDialogRejectApprove() {
      this.dialogRejectApprove = false;
    },
  },

  destroyed() {
  },
};
</script>
